import { create } from 'zustand'
import type { Location, Wall } from '../types'

interface SelectionState {
  selectedZone: Location | null
  selectedWall: Wall | null
  editMode: 'none' | 'zone' | 'wall' | 'path'
  isDragging: boolean
  selectZone: (z: Location | null) => void
  selectWall: (w: Wall | null) => void
  setEditMode: (m: 'none' | 'zone' | 'wall' | 'path') => void
  setDragging: (d: boolean) => void
  clearSelection: () => void
}

export const useSelectionStore = create<SelectionState>((set) => ({
  selectedZone: null,
  selectedWall: null,
  editMode: 'none',
  isDragging: false,
  selectZone: (z) => set({ selectedZone: z, selectedWall: null }),
  selectWall: (w) => set({ selectedWall: w, selectedZone: null }),
  setEditMode: (m) => set({ editMode: m }),
  setDragging: (d) => set({ isDragging: d }),
  clearSelection: () => set({ selectedZone: null, selectedWall: null }),
}))
